import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import axios from 'axios'
import { useLocation, useNavigate } from 'react-router'
import { route_base_url } from '../../pages/stops/utils'

// Components
import SubTitle from '../common/SubTitle'
import TitleBar from '../navbar/TitleBar'
import NavMenu from '../navbar/NavMenu'
import SearchFilter from '../common/SearchFilter'
import DynamicTable from '../common/DynamicTable'
import { ACTIONS_COLUMN_ID } from "../../constants/dashboardConstants";

function RouteSchedule() {
  const location = useLocation()
  const navigate = useNavigate()
  const id = location.state?.id
  const [scheduleData, setScheduleData] = useState({})
  const [isLoading, setIsLoading] = useState(true)
  const [tableData, setTableData] = useState([])

  // Define table headers as strings, not objects
  // const headers = ['Schedules', 'Description', 'Start Time', 'End Time', 'Repetition']
  const headers = [
    { key: "Schedules", value: 'Schedules' },
    { key: "Description", value: 'Description' },
    { key: "Start Time", value: 'Start Time' },
    { key: "End Time", value: 'End Time' },
    { key: "Repetition", value: 'Repetition' },
    { key: ACTIONS_COLUMN_ID, value: 'Actions' }
  ];



  // Keep the original header objects for reference
  const headerObjects = [
    { id: 'name', label: 'Schedules', sortable: true },
    { id: 'description', label: 'Description', sortable: false },
    { id: 'startTime', label: 'Start Time', sortable: true },
    { id: 'endTime', label: 'End Time', sortable: false },
    { id: 'repetition', label: 'Repetition', sortable: false }
  ]

  // Define filter config
  const filterConfig = [
    {
      label: "Repetition",
      name: "repetition",
      options: [
        { value: "All", label: "All" },
        { value: "Daily", label: "Daily" },
        { value: "Weekly", label: "Weekly" },
        { value: "Monthly", label: "Monthly" }
      ]
    }
  ]

  useEffect(() => {
    async function fetchSchedules() {
      try {
        if (id) {
          setIsLoading(true)
          const response = await axios.get(`${route_base_url}/id`, {
            params: { id }
          })
          console.log("route for schedules ", response.data)
          setScheduleData(response.data)

          // Process schedule data for the table and format it
          if (response.data.schedules && Array.isArray(response.data.schedules)) {
            setTableData(formatScheduleData(response.data.schedules))
          }

          setIsLoading(false)
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          console.log("Unauthorized request")
          navigate("/")
          return
        }
        console.log("error in fetching route", error)
        setIsLoading(false)
      }
    }
    fetchSchedules()
  }, [id, navigate])

  // Format schedule data to match expected table format
  const formatScheduleData = (schedules) => {
    return schedules.map(schedule => {
      return {
        'Schedules': schedule.name || 'N/A',
        'Description': schedule.description || 'N/A',
        'Start Time': schedule.startTime || 'N/A',
        'End Time': schedule.endTime || 'N/A',
        'Repetition': schedule.repetition || 'N/A',
        // Keep original data for reference
        originalData: schedule
      };
    });
  }

  const handleSearchChange = (searchText) => {
    // Filter table data based on search text
    if (!scheduleData.schedules) return

    if (!searchText) {
      setTableData(formatScheduleData(scheduleData.schedules))
      return
    }

    const filtered = scheduleData.schedules.filter(item =>
      item.name?.toLowerCase().includes(searchText.toLowerCase()) ||
      item.description?.toLowerCase().includes(searchText.toLowerCase())
    )

    setTableData(formatScheduleData(filtered))
  }

  const handleFilterChange = (filterName, value) => {
    // Filter table data based on filter selection
    if (!scheduleData.schedules) return

    if (filterName === 'repetition') {
      if (value === 'All') {
        setTableData(formatScheduleData(scheduleData.schedules))
        return
      }

      const filtered = scheduleData.schedules.filter(item =>
        item.repetition?.toLowerCase() === value.toLowerCase()
      )

      setTableData(formatScheduleData(filtered))
    }
  }

  return (
    <>
      <TitleBar />
      <NavMenu />
      <div className="page_container">
        <SubTitle
          title="Route Schedule"
          path="Routes > Update Route > Route Schedules"
        />
        <Box
          sx={{
            display: "flex",
            height: "60px",
            justifyContent: "space-between",
            padding: "12px 16px",
            margin: "0px 40px",
            backgroundColor: "#FFFFFF",
            boxShadow: "0px 2px 5px 0px #00000040",
          }}
        >
          <Box
            sx={{
              fontWeight: 500,
              fontFamily: 'Roboto',
              fontSize: '20px',
              lineHeight: '100%',
              letterSpacing: '0%',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <span style={{ color: '#414958', padding: '2px 6px', borderRadius: '2px' }}>
              Route:
            </span>
            <span style={{
              fontWeight: 600,
              fontFamily: 'Roboto',
              fontSize: '20px',
              lineHeight: '100%',
              letterSpacing: '0%',
              color: '#183059',
              padding: '2px 6px',
              borderRadius: '2px',
              marginLeft: '4px'
            }}>
              {scheduleData.name || "-"}
            </span>
          </Box>
          <Box
            sx={{
              fontWeight: 500,
              fontFamily: 'Roboto',
              fontSize: '20px',
              lineHeight: '100%',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <span style={{ color: '#414958', padding: '2px 6px', borderRadius: '2px' }}>
              Route ID:
            </span>
            <span style={{
              fontWeight: 600,
              fontFamily: 'Roboto',
              fontSize: '20px',
              lineHeight: '100%',
              color: '#183059',
              padding: '2px 6px',
              borderRadius: '2px',
              marginLeft: '4px'
            }}>
              {scheduleData.routeId || "-"}
            </span>
          </Box>
        </Box>
        <Box sx={{
          margin: "20px 40px",
          borderRadius: "10px",
          padding: "24px",
          border: "1px solid #A5DCF3",
          boxShadow: "-2px 1px 5px 0px #00000040"
        }}>
          <SearchFilter
            filters={filterConfig}
            searchPlaceholder="Search..."
            onSearchChange={handleSearchChange}
            onFilterChange={handleFilterChange}
          />

          <DynamicTable
            headers={headers}
            data={tableData}
            loading={isLoading}
          />
        </Box>
      </div>
    </>
  )
}

export default RouteSchedule